import { type JsonDataItem } from '@g2u/ui-kit';
import { baseQuery } from '../baseQuery';

export const getCustomerDiscounts = async ({ queryKey }: JsonDataItem) => {
  const customerId = queryKey[1] ? `&customer_id=${queryKey[1]}` : '';
  const { data } = await baseQuery(`customer-system-discounts?type=customer${customerId}&per_page=150`);

  return data;
};
